<template>
  <a-modal v-model="modal" title="刷新日工资" width="500px" :maskClosable="false" :closable="false">
    <a-form-model
      :model="formData"
      ref="form"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item
        label="组织"
        prop="organizationCode"
        :rules="rules"
      >
        <global-select
          class="full-width"
          v-model="formData.organizationCode"
          :allow-clear="false"
          :dropdown-match-select-width="false"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
      </a-form-model-item>
      <a-form-model-item
        label="日期范围"
        prop="refreshTime"
        :rules="rules"
      >
        <a-range-picker
          class="full-width"
          v-model="formData.refreshTime"
          format="YYYY-MM-DD"
          :disabled-date="disabledDate"
        />
      </a-form-model-item>
      <a-form-model-item
        label="MO票号"
        prop="moTicketCode"
      >
        <a-input v-model="formData.moTicketCode" allowClear />
      </a-form-model-item>
      <a-form-model-item
        label="成品SKU"
        prop="assemblyItemCode"
      >
        <global-select
          class="full-width"
          v-model="formData.assemblyItemCode"
          selectType="selectAssembleSearch"
          requestApi="/mes/mesDiscreteJobs/assemblyBox"
          :selectItem="{ value: 'selectedValue', label: 'bringOutDataOne' }"
          searchParam="itemCode"
          :dropdown-match-select-width="false"
          placeholder="请选择成品SKU"
          allowClear
        />
      </a-form-model-item>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button :loading="loading" @click="onClose">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import moment from 'moment';
import { apiRefreshDailySalary } from '@/api/mes/productionPrepare/ccPieceworkWage'
import { mapState } from 'vuex';

export default {
  name: 'UpdateDayWageModal',
  props: {
    mainBtnLoading: Boolean
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      modal: false,
      formData: {
        refreshTime: [this.$moment(), this.$moment()],
        organizationCode: '',
        moTicketCode: '',
        assemblyItemCode: ''
      },
      loading: false,
      rules: [{ required: true, message: ' ', trigger: 'change' }],
      selectedRows: []
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode,
      inventOrg: (state) => state.user.inventOrg
    })
  },
  methods: {
    moment,
    show () {
      this.formData.refreshTime = [this.$moment(), this.$moment()];
      this.formData.organizationCode = this.organizationCodeOrigin;
      this.formData.moTicketCode = '';
      this.formData.assemblyItemCode = '';
      this.modal = true
    },
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          this.loading = true;
          this.$emit('update:mainBtnLoading', true);
          const params = {
            refleshTimeStart: this.$moment(this.formData.refreshTime[0]).format('YYYY-MM-DD 00:00:00'),
            refleshTimeEnd: this.$moment(this.formData.refreshTime[1]).format('YYYY-MM-DD 23:59:59'),
            organizationCode: this.formData.organizationCode
          }

          // 只有在有值的时候才添加到参数中
          if (this.formData.moTicketCode) {
            params.moTicketCodeList = [this.formData.moTicketCode];
          }
          if (this.formData.assemblyItemCode) {
            params.assemblyItemCode = this.formData.assemblyItemCode;
          }

          apiRefreshDailySalary(params).then(response => {
            if (response.code === 200) {
              this.onClose();
              this.$message.success(response.data)
              this.$emit("successCall")
            } else {
              this.$message.error(response.msg)
            }
          }).finally(() => {
            this.loading = false
            this.$emit('update:mainBtnLoading', false);
          })
        }
      })
    },
    onClose() {
      this.modal = false;
      this.$refs.form.resetFields();
    },
    // 选择限制当前和以后日期
    disabledDate (current) {
      return current > this.$moment().endOf('day');
    }
  }
}
</script>

<style scoped>
.full-width {
  width: 100%;
}
</style>
